<template>
    <div>
        <v-menu offset-y left>
            <template v-slot:activator="{ on, attrs }">                
                <v-btn
                    class="elevation-4"
                    v-bind="attrs"
                    v-on="on"
                    style="background-color: #1c1c44; color: white;"
                >
                    <v-icon left>mdi-menu</v-icon>
                    Navegação
                </v-btn>
            </template>

            <v-list style="background-color: #1c1c44;">
                <v-list-item v-for="(parent) in parents" :key="parent.key">
                    <v-list-item-title class="cursor-pointer" style="font-size: 12px; color: white;" @click="navigator(parent)">
                        <v-menu
                            v-if="parent.children.length > 0"
                            offset-x
                            open-on-hover
                            left
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-list-item
                                    v-bind="attrs"
                                    v-on="on"
                                    class="d-flex justify-space-between mr-n2"
                                >
                                    <v-icon left class="white--text">mdi-chevron-left</v-icon>
                                    <v-list-item-title style="font-size: 12px; color: white;">
                                        {{ parent.title }}
                                    </v-list-item-title>
                                </v-list-item>
                            </template>
                            <v-list style="background-color: #1c1c44;">
                                <v-list-item
                                    v-for="(child) in parent.children"
                                    :key="child.key"
                                    class="cursor-pointer d-flex justify-end"
                                >
                                    <v-list-item-title class="cursor-pointer white--text" style="font-size: 12px" @click="navigator(child)">{{ child.title }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                        <span v-else class="d-flex justify-end">{{ parent.title }}</span>
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
    export default {
        name: 'DropdownCaptacaoV2',
        props: {
        },
        data() {
          return {
            parents: [
              {
                key: 'projetos-captacao',
                title: "Projetos",
                route: { name: "projetos-captacao" },
                children: []
              },             
              {
                key: 'comprovacao-orçamento',
                title: "Resumo (PREV/REAL)",
                route: { name: "comprovacao-orcamento" },
                children: []
              },
              {
                key: 'dispêndios',
                title: 'Dispêndios',
                children: [
                  {
                    key: 'captacao-dispendio-rh',
                    title: 'Dispêndio com RH',
                    route: { name: 'captacao-dispendio-rh' },
                    children: []
                  },
                  {
                    key: 'lancamentos',
                    title: 'Lançamento de despesas',
                    route: { name: 'demais-dispendios' },
                    children: []
                  },
                  {
                    key: 'timesheets-captacao',
                    title: 'Timesheets',
                    route: { name: 'timesheets-captacao' },
                    children: []
                  },
                ]
              },
            ]
          }
        },
        computed: {
          projetoId() {
            return this.$route.params.id;
          },
        },
        methods: {
          navigator(target) {
            const routeName = target.route.name;
            if(routeName === 'em-dev') {
              return alert('Em desenvolvimento');
            }
            this.$router.push({ name: routeName, params: { id: this.projetoId }});
          }
        },

    }
</script>